export enum Routes {
  HOME_INDEX = 'home.index',
  LOGIN_INDEX = 'login.index',

  SALES_LEADS_DETAIL = 'sales.leads.detail',

  SALES_DASHBOARD_INDEX = 'sales.dashboard.index',

  SALES_COMMISSIONS_INDEX = 'sales.commissions.index',
  SALES_CONTRACTS_INDEX = 'sales.contracts.index',
  SALES_ELECTRONIC_CONTRACTS_INDEX = 'sales.electronic-contracts.index',
  SALES_EVENTS_INDEX = 'sales.events.index',
  SALES_SALES_INDEX = 'sales.sales.index',

  SALES_CASES_INDEX = 'sales.cases.index',
  SALES_CASES_TABLE = 'sales.cases.table',
  SALES_CASES_KANBAN = 'sales.cases.kanban',
  SALES_CASES_MAP = 'sales.cases.map',
  SALES_CASES_SUMMARY = 'sales.cases.summary',
  SALES_CASE_DETAIL = 'sales.cases.detail',

  SALES_REFERENCE_SETS_INDEX = 'sales.reference-sets.index',
  SALES_REFERENCE_SETS_DETAIL = 'sales.reference-sets.detail',

  SALES_SALESMEN_INDEX = 'sales.salesmen.index',

  PROPERTIES_INDEX = 'properties.index',
  PROPERTIES_REVIEWS = 'properties.reviews',
  PROPERTIES_FRAUDS = 'properties.frauds',
  PROPERTIES_CONFIRMED_UNSUCCESSFUL_RESERVATIONS = 'properties.confirmed.unsuccessful.reservations',
  PROPERTIES_RESERVATIONS = 'properties.reservations',
  PROPERTIES_MAP = 'properties.map',
  PROPERTIES_DETAIL = 'properties.detail',

  OTA_PARTNERS = 'ota.partners',
  OTA_COOPERATION = 'ota.cooperation',

  OTA_CM_ROOMS_PLANNING = 'ota.cm.rooms.planning',
  OTA_CM_REQUEST = 'ota.cm.request',
  OTA_CM_LOGIN_CREDENTIALS = 'ota.cm.login.credentials',
  OTA_CM_RESERVATIONS = 'ota.cm.reservations',
  OTA_CM_STATUS = 'ota.cm.status',
  OTA_CM_DASHBOARD = 'ota.cm.dashboard',
  OTA_DEV_TOOLS_CHM_CONNECTIONS = 'ota.dev-tools.chm-connections',
  OTA_DEV_TOOLS_RESERVATION_ROOM_LOOKUP = 'ota.dev-tools.reservation-room-lookup',
  OTA_DEV_TOOLS_ICAL_VIEWER = 'ota.dev-tools.ical-viewer',

  INVOICE_FEE_INVOICES = 'invoice.fee.invoices',
  INVOICE_SALES_INVOICES = 'invoice.sales.invoices',
  INVOICE_COMMISSION_INVOICES = 'invoice.commission.invoices',
  INVOICE_PERFORMANCE_INVOICES = 'invoice.performance.invoices',
  INVOICE_FEES_REPORT = 'invoice.fees.report',
  INVOICE_COMMISSION_REPORT = 'invoice.commission.report',
  INVOICE_COMMISSION_PER_HOTEL = 'invoice.commission.per.hotel',
  INVOICE_IMPORT_BANK_STATEMENTS = 'invoice.import.bank.statements',
  INVOICE_BANK_OPERATIONS = 'invoice.bank.operations',

  USERS_INDEX = 'users.index',
  USERS_EMPLOYEES = 'users.employees',
  USERS_API_USERS = 'users.apiUsers',
  USERS_API_USERS_INTEGRATION_PARTNERS = 'users.apiUsers.integrationPartners',
  USERS_ROLE = 'users.role',
  USERS_GROUPS = 'users.groups',
  USERS_ACTIVITY = 'users.activity',

  SYSTEM_PAY_TERMINALS = 'system.pay.terminals',
  SYSTEM_PAY_ONLINE_GATEWAY = 'system.pay.online.gateway',
  SYSTEM_SITES = 'system.sites',
  SYSTEM_ENUMERATIONS_SPA_PROCEDURES = 'system.enumerations.spa.procedures',
  SYSTEM_TIPBOX = 'system.tipbox',
  SYSTEM_FEEDBACK = 'system.feedbox',
  SYSTEM_PMS_VERSION_OVERRIDES = 'system.pms-version-overrides',
  SYSTEM_PMS_VERSION_OVERRIDES_TABLE = 'system.pms-version-overrides.table',
  SYSTEM_PMS_VERSION_OVERRIDES_STATISTICS = 'system.pms-version-overrides.statistics',
  SYSTEM_ERRORS = 'system.errors',
  SYSTEM_NTAK_VERSION = 'system.ntakVersion',

  BACKOFFICE_CONTACT_PERSON_INDEX = 'backoffice.contact-person.index',
  BACKOFFICE_CONTACT_PERSON_DETAIL = 'backoffice.contact-person.detail',
}
